import React__default from 'react';
import { LobbyLoadingInfoWr } from '../lobbyLoadingInfoWr/index.js';

var TableLoading = function (_a) {
    var bgImage = _a.bgImage, progress = _a.progress, gameLogo = _a.gameLogo, isAdditionalLoading = _a.isAdditionalLoading, additionalImgSrc = _a.additionalImgSrc; _a.forLoading; var lobbyName = _a.lobbyName, tableText = _a.tableText, logoPG = _a.logoPG;
    return (React__default.createElement("div", { className: 'pgc-loading', style: { backgroundImage: "url(".concat(bgImage, ")") } },
        React__default.createElement("div", { className: 'pgc-loading-content' },
            React__default.createElement(LobbyLoadingInfoWr, { gameLogo: gameLogo },
                React__default.createElement("h3", { className: 'pgc-common-room-name' }, lobbyName),
                React__default.createElement("p", { className: 'pgc-room-info-text' }, tableText),
                !isAdditionalLoading
                    ? React__default.createElement("div", { className: 'pgc-loading-row' },
                        React__default.createElement("span", { style: { width: "".concat(progress, "%") } }))
                    : React__default.createElement("div", { className: "bog-loader-outer" },
                        React__default.createElement("div", { className: "bog-loader-inner" },
                            React__default.createElement("img", { src: additionalImgSrc, alt: "" }),
                            React__default.createElement("div", { className: "bog-loader-row" },
                                React__default.createElement("div", { className: "bog-loader-line", style: { transform: "translateX(-".concat(100 - progress, "%)") } }))))),
            React__default.createElement("div", { className: 'pgc-loading-logo-holder' },
                React__default.createElement("img", { src: logoPG, alt: "logo" })))));
};

export { TableLoading };
